export const IOS_APP_STORE_URL = String(
  process.env.REACT_APP_IOS_APP_STORE_URL ||
    "https://apps.apple.com/ca/app/medidoze-delivery/id6762501726",
).trim();

export const IOS_APP_UNIVERSAL_LINK = String(
  process.env.REACT_APP_IOS_APP_UNIVERSAL_LINK ||
    "",
).trim();

export const ANDROID_PLAY_STORE_URL = String(
  process.env.REACT_APP_ANDROID_PLAY_STORE_URL ||
    "https://play.google.com/store/apps/details?id=com.medidoze.delivery.app",
).trim();
